import React from 'react';
import { ArrowRight, Zap, Store, TrendingUp } from 'lucide-react';

const Hero = () => {
  return (
    <div className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-gray-50 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23F46B6A' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="container mx-auto px-6 py-24 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-coral-light border-2 border-coral mb-8">
            <Zap className="w-4 h-4 text-coral" />
            <span className="text-sm font-semibold text-coral">Next Gen Quick Commerce</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl lg:text-7xl font-bold leading-tight text-gray-900 mb-6">
            Empowering the
            <span className="block text-coral mt-2">Future of Retail</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl lg:text-2xl text-gray-600 leading-relaxed mb-8 max-w-3xl mx-auto">
            A tech and logistics platform transforming retail stores into hyperlocal powerhouses. 
            Delivering in <span className="font-bold text-coral">minutes, not days</span>.
          </p>

          {/* Key Points */}
          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto mb-8">
            <div className="flex items-start gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
              <Store className="w-6 h-6 text-coral flex-shrink-0 mt-1" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900 mb-1">For Retailers</h3>
                <p className="text-sm text-gray-600">Online presence + Smart logistics</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-xl bg-white shadow-sm border border-gray-100">
              <TrendingUp className="w-6 h-6 text-coral flex-shrink-0 mt-1" />
              <div className="text-left">
                <h3 className="font-semibold text-gray-900 mb-1">Data-Driven</h3>
                <p className="text-sm text-gray-600">Consumer insights for retailers</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="#contact"
              className="btn-primary group"
            >
              Get in Touch
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#how-it-works"
              className="btn-secondary"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
